export const FETCH_BRANDS_REQUEST = 'FETCH_BRANDS_REQUEST';
export const FETCH_BRANDS_SUCCESS = 'FETCH_BRANDS_SUCCESS';
export const FETCH_BRANDS_FAILURE = 'FETCH_BRANDS_FAILURE';

export const FETCH_BRAND_REQUEST = 'FETCH_BRAND_REQUEST';
export const FETCH_BRAND_SUCCESS = 'FETCH_BRAND_SUCCESS';
export const FETCH_BRAND_FAILURE = 'FETCH_BRAND_FAILURE';

export const UPDATE_BRANDS_REQUEST = 'UPDATE_BRANDS_REQUEST';
export const UPDATE_BRANDS_SUCCESS = 'UPDATE_BRANDS_SUCCESS';
export const UPDATE_BRANDS_FAILURE = 'UPDATE_BRANDS_FAILURE';

export const DELETE_BRANDS_REQUEST = 'DELETE_BRANDS_REQUEST';
export const DELETE_BRANDS_SUCCESS = 'DELETE_BRANDS_SUCCESS';
export const DELETE_BRANDS_FAILURE = 'DELETE_BRANDS_FAILURE';

export const CLEAR_BRAND_ERRORS = 'CLEAR_BRAND_ERRORS';
export const CLEAR_BRAND_SUCCESS = 'CLEAR_BRAND_SUCCESS';
